'use client';
import MuiFormControlLabel from '@mui/material/FormControlLabel';
import React from 'react';
import { makeStyles } from 'tss-react/mui';

import { black } from '../../colors';
import withRef from '../../utils/withRef';

export const styles = {
  checkedLabel: {
    color: `${black} !important`,
    fontWeight: 500,
  },
  small: {
    '&.MuiFormControlLabel-label': {
      fontSize: 14,
      paddingTop: 2,
      paddingBottom: 2,
      lineHeight: '20px',
    },
  },
  label: {},
};

const useStyles = makeStyles()(styles);

export const FormControlLabel = ({ checked, indeterminate, size, forwardedRef: ref, ...rest }) => {
  const { classes, cx } = useStyles();

  return (
    <MuiFormControlLabel
      classes={{
        root: classes.root,
        label: cx(
          classes.label,
          checked && classes.checkedLabel,
          indeterminate && classes.checkedLabel,
          size === 'small' && classes.small
        ),
      }}
      {...rest}
      ref={ref}
    />
  );
};

export default withRef()(FormControlLabel);
